import React, { Component } from 'react';
import './DegreeCard.css';
import { Fade, Flip } from 'react-reveal';


class DegreeCard extends Component {
	render() {
		const degree = this.props.degree;
		const theme = this.props.theme;
		return (
			<div className="degree-card">
				<Flip left duration={2000}>
				</Flip>
				<Fade right duration={2000} distance="40px">
					<div className="card-body">
						<div className="body-header" style={{ backgroundColor: theme.headerColor }}>
							<div className="body-header-title">
								<h1 className="card-title" style={{ color: theme.text }}>
									Bachelors Degree
								</h1>
								<h3 className="card-subtitle" style={{ color: theme.text }}>
									{degree.subtitle}
								</h3>
							</div>
							<div className="body-header-duration">
								<h3 className="duration" style={{ color: theme.text }}>
									{degree.duration}
								</h3>
							</div>
						</div>
						<div classname="body-content">
							{degree.descriptions.map((sentence) => {
								return (
									<p className="content-list" style={{ color: theme.text }}>
										{sentence}
									</p>
								);
							})}
						</div>
					</div>
				</Fade>
			</div>
		);
	}
}

export default DegreeCard;